<template>
  <iframe
    v-if="config && config.LOGIN_SERVICE_URL"
    :src="`${config.LOGIN_SERVICE_URL}/heartbeat`"
    style="width: 0; height: 0; border: 0; position: absolute"
  ></iframe>
</template>

<script>
  export default { name: 'sso-update' };
</script>
